export default {
    another: 'Outro',
    continue: 'Continuar',
    validUntil: 'Data expiração',
    paymentPlan: 'pagar ({planValue})',
    subTitle: 'Valor total: <em>{planValue}</em>',

    titles: {
        payment: 'Dados pagamento',
        personal: 'Dados pessoais',
        address: 'Dados endereço',
    },

    placeholders: {
        cvv: 'CVV',
        numberCard: 'Número cartão',
        expirationCard: 'Data expiração',
        nameCard: 'Nome (igual como está no cartão)',
        couponError: 'Código inválido',
        insertCoupon: 'Inserir cupom de desconto',
        coupon: 'CUPOM',
        removeCoupon: 'Remover',
        applyCoupon: 'Aplicar',
        discountApplied: 'Desconto aplicado',

        personalCity: 'Cidade',
        personalCountry: 'País',
        personalDocumentAbrv: 'CPF',
        personalDocument: 'Documento',
        personalProvince: 'Estado/Provincia/Região',
        personalStreetNumber: 'Número',
        personalName: 'Nome completo',
        personalZipCode: 'Código postal',
        personalEmail: 'E-mail',
        personalAddress: 'Endereço',
        personalNeighborhood: 'Bairro',
        personalPhoneNum: 'Telefone (+00 00 0000 0000)',
    },

    errors: {
        invalidCvv: '^Cvv inválido',
        invalidDate: '^Data inválida',
        emptyField: '^Campo vazio!',
        invalidCoupon: 'Código inválido!',
        expiredCard: 'Cartão expirado',
        invalidEmail: '^E-mail inválido',
        invalidCard: '^Cartão inválido',
        documentNumericOnly: 'Somente números',
        invalidDocument: '^Documento inválido',
    },
};
